import { Box } from "@mui/material"
import StepCard from "./StepView/StepView";
import { Key, useEffect, useState } from "react";


const initialStepData = [
    {title:"Step 1", state:"current",step:1},
    {title:"Step 2", state:"incomplete",step:2},
    {title:"Step 3", state:"incomplete",step:3},
    {title:"Step 4", state:"incomplete",step:4},
    {title:"Step 5", state:"incomplete",step:5},


]


const MultiStepper =(props: any) =>{

  const {currentStep, iComponetTranslate} = props;

  const[stepDataList,setStepData] = useState<any[]>(initialStepData);

  const t = (name: string) => {
    const ifExist: any = iComponetTranslate.filter((item: any) => item.label === name);
    if (ifExist.length > 0) {
        return ifExist[0].value ? ifExist[0].value : `No translate found (${ifExist[0].label})`;
    }
    return `No key found (${name})`;
}


  useEffect(() => {
    // Ensure currentStep is within valid bounds
    const validCurrentStep = Math.min(Math.max(currentStep, 1), initialStepData.length);

    const updatedSteps = initialStepData.map((step) => {
      if (step.step < validCurrentStep) {
        return { ...step, state: "completed" };
      } else if (step.step === validCurrentStep) {
        return { ...step, state: "current" };
      } else {
        return { ...step, state: "incomplete" };
      }
    });

    setStepData(updatedSteps);
    console.log(currentStep, "step", updatedSteps);
  }, [currentStep]);



    return(
        <Box sx ={{display:"flex", flexDirection:"column", alignSelf:"center"}}> 
         <Box className="fw-600" sx={{ color: "#012445", fontSize: "40px;", lineHeight: "normal" , padddingBottm:"20px", justifyContent:"center", display:"flex"}}>{t("CreateCustomer")}</Box>
          <Box sx={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
          {stepDataList.map((item: any, index: Key | null | undefined)=>(
            <div key={index}>
            <StepCard data ={item}/>
            </div>
          ))}
          </Box>
        </Box>
    )



}

export default MultiStepper;